export const companyName = 'Goodnet By Artamedia'
export const version = '0.1.3'